export default {
    install(Vue) {

        // Global public methods

        /**
         * Formats date string with lan locale.
         * @param   {string}    dateStr
         * @param   {string}    lan
         * @returns {string}
         */
         Vue.prototype.$formatDate = (dateStr, lan) => {
            if (dateStr === null) {
                return dateStr;
            }
            // The replace thingy is for Safari compatibility
            let date = new Date(dateStr.replace(/-/g, '/'));
            return date.toLocaleDateString(lan);
        };

        /**
         * Formats datetime string with lan locale.
         * @param   {string}    dateStr
         * @param   {string}    lan
         * @returns {string}
         */
         Vue.prototype.$formatDateTime = (dateStr, lan) => {
            // The replace thingy is for Safari compatibility
            let date = new Date(dateStr.replace(/-/g, '/'));
            return date.toLocaleString(lan);
        };

        Vue.prototype.$setIconUrl = function(iconUrl, themeColor, themeTextColor) {
            if (! iconUrl) {
                return iconUrl;
            }
            if (iconUrl.search('.svg') != -1 || iconUrl.search('/markers-custom') != -1) {
                if (iconUrl.search('/markers-custom') != -1 && iconUrl.search('fillColor') == -1) {
                    // Custom icon, no colors defined in url, add color parameters
                    iconUrl += '&borderColor=' + encodeURIComponent(themeTextColor) + '&fillColor=' + encodeURIComponent(themeColor) + '&iconColor=' + encodeURIComponent(themeTextColor);
                } else if (iconUrl.search('/markers-custom') != -1) {
                    // Custom icon, with colors defined, leave as it is
                } else if (iconUrl.search(process.env.VUE_APP_LOCATIONS_PATH) != -1 && iconUrl.search('/user-markers') == -1) {
                    // Locations DB marker icon with absolute path, add color parameters
                    iconUrl = process.env.VUE_APP_LOCATIONS_PATH + 'images/markers/svg-marker-icon.php?url=' + iconUrl.split(/[\\/]/).pop() + '&borderColor=' + encodeURIComponent(themeTextColor) + '&fillColor=' + encodeURIComponent(themeColor) + '&iconColor=' + encodeURIComponent(themeTextColor) + '&v=2021-09-29';
                } else {
                    // Non Locations DB marker icon
                    iconUrl = process.env.VUE_APP_LOCATIONS_PATH + 'images/markers/svg-marker-icon.php?url=' + iconUrl + '&borderColor=' + encodeURIComponent(themeTextColor) + '&fillColor=' + encodeURIComponent(themeColor) + '&iconColor=' + encodeURIComponent(themeTextColor) + '&v=2021-09-29';
                } 
            }
            return iconUrl;
        }
        /**
         * Returns theme text color based on themeColor brightness.
         * 
         * @param   {string}    themeColor   Valid color value
         * @returns {string}
         */
        Vue.prototype.$setThemeTextColor = function(themeColor) {
            let rgb;

            if (themeColor.search('#') !== -1) {
                // It's a hex value
                rgb = hexToRgb(themeColor);
            //} else if (false) {
                // It's rgb value
                // TO DO
            //} else if (false) {
                // It's hsl value
                // TO DO
            } else {
                // Color type not supported, revert to default
                return '#fff';
            }
            // Calculate RGB brightness sum
            let sum = Math.round(((parseInt(rgb.r) * 299) + (parseInt(rgb.g) * 587) + (parseInt(rgb.b) * 114)) / 1000);
            // Return black or white with threshold of 128
            return (sum > 128) ? '#000' : '#fff';
        }

        /**
         * Returns theme hover color based on themeColor.
         * 
         * @param   {string}    themeColor   Valid color value
         * @returns {string}
         */
        Vue.prototype.$setThemeHoverColor = function(themeColor) {
            if (themeColor.search('#') !== -1) {
                // It's a hex value
                if (this.themeTextColor == '#fff') {
                    return lightenDarkenHexColor(themeColor, -30);
                } else {
                    return lightenDarkenHexColor(themeColor, 30);
                }
            //} else if (false) {
                // It's rgb value
                // TO DO
            //} else if (false) {
                // It's hsl value
                // TO DO
            } else {
                // Color type not supported, revert to default
                return '#3c9';
            }
        }
        
        // Private methods

        /**
         * Converts hex RGB color value to integer RGB values.
         * 
         * @param   {string}    hex Valid hex color value
         * @returns {object}
         */
         function hexToRgb(hex) {
            // Expand 3-digit shorthand ("#f00") to 6-digit ("#ff0000")
            let shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
            hex = hex.replace(shorthandRegex, function(m, r, g, b) {
                return r + r + g + g + b + b;
            });

            let result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
            return result ? {
                r: parseInt(result[1], 16),
                g: parseInt(result[2], 16),
                b: parseInt(result[3], 16)
            } : null;
        }

        /**
         * @param   {string}    color   Hex color value
         * @param   {number}    amount  Positive number for lighten, negative for darken
         * @returns {string}
         */
         function lightenDarkenHexColor(color, amount) {
            return '#' + color.replace(/^#/, '').replace(/../g, color => ('0'+Math.min(255, Math.max(0, parseInt(color, 16) + amount)).toString(16)).substr(-2));
        }
        
    }
};